import { faAdd, faBox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ErrorMessage, Formik, useField, useFormikContext } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import {
  Accordion,
  Badge,
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Stack,
} from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import * as Yup from "yup";
import {
  format_currency_2,
  format_percent_2
} from "../../common/format.js";
import T from "../../common/traducao.js";
import { GetConfiguracoes } from "../../config/localstorageConfig/localstorage";
import { OrcamentoVendaContext } from "../../contexts/orcamentovenda-context";
import ErrosModal from "../../errors/ModalErrors/index.jsx";
import { useAtalhos } from "../../hooks/useAtalhos/index.js";
import OrcamentoVendaService from "../../services/service.orcamentovenda.js";
import ProdutoService from "../../services/service.produto.js";
import "../../styles/botoesBuscar.css";
import CampoMemo from "../campos_comp/campo-memo.jsx";
import CamposSearchListProduto from "../campos_comp/campo-searchlist-produto.jsx";
import NewComposicaoProdutoControl from "../composicao_comp/composicao-ProdutoControl.jsx";
import CalculatedControl from "../controls_comp/control-calculated.jsx";
import NewCheckBoxControl from "../controls_comp/control-checkbox.jsx";
import EditControl from "../controls_comp/control-edit.jsx";
import NewGruposProdutosVendasControl from "../controls_comp/control-gruposprodutosvenda.jsx";
import PrecosScriptControl from "../controls_comp/control-select-precos-script.jsx";
import NewSelectControl from "../controls_comp/control-selectcontrol.jsx";
import ItemOrcamentoVendaCondicoesEspeciaisCtx from "../item_orcamento_venda/itemorcamentovenda-condicoesespeciais.jsx";
import NewSearchListReferenciaProduto from "../searchs_comp/search-List.Referencia.Produto.jsx";
import ModalAtalhos from "../ui_comp/Modals/ModalAtalhos.jsx";
import ModalAtributosProdutoControl from "../ui_comp/Modals/ModalAtributosProduto.jsx";
import ModalComposicaoProdutoControl from "../ui_comp/Modals/ModalComposicaoProduto.jsx";

const initialValues = {
  ItemOrcamentoVenda: {
    Item: 1,
    Id: 0,
    Quantidade: null,
    CodProduto: "",
    NomeProduto: "",
    Referencia: "",
    UnidadeMedida: "PC",
    PercentualDesconto: 0,
    PercentualAcrescimo: 0,
    DescontoEspecial: 0,
    PrecoTabela: 0,
    PrecoTabelaComDesconto: 0,
    PrecoUnitario: 0,
    TotalItem: 0,
    Projeto: null,
    Observacoes: null,
    TabelaPrecoId: null,
  },
};

const ItemOrcamentoVendaNew = (props) => {
  const {
    ItensFiname,
    TabelaPrecoId,
    selectedItem,
    indexselectedItem,
    cfop,
    maioritem,
    orcamentovenda,
    configs,
    somenteLeitura,
    descontosTabela,
    toggle,
  } = props;

  const configGeral = GetConfiguracoes();

  const itensFiname = ItensFiname?.map((item, index) => {
    return { Id: index, Valor: item.NomeProduto };
  });

  const _initialvalues = { ItemOrcamentoVenda: selectedItem };

  initialValues.ItemOrcamentoVenda.TabelaPrecoId = TabelaPrecoId;
  initialValues.ItemOrcamentoVenda.Cfop = cfop;
  initialValues.ItemOrcamentoVenda.Item = maioritem ? maioritem + 1 : 1;
  const formikRef = useRef(null)
  const [modalComposicao, setModalComposicao] = useState(false);
  const [modalAtributos, setModalAtributos] = useState(false);
  const [modalAtalhos, setModalAtalhos] = useState(false);
  const [valoresComissoes, setValoresComissoes] = useState(null);
  const [indexPrecoComissao, setIndexPrecoComissao] = useState(null);
  const [deveRecalcular, setDeveRecalcular] = useState(false);

  const [multiplos, setMultiplos] = useState(
    _initialvalues?.ItemOrcamentoVenda?.QtdeMultiplaVenda
  );

  const [devePreencherAtributos, setDevePreencherAtributos] = useState(
    configs?.UsarAtributosVenda &&
    _initialvalues?.ItemOrcamentoVenda?.FormulaParaQuantidadeId > 0
  );
  const [deveMostrarSobMedida, setDeveMostrarSobMedida] = useState(
    _initialvalues?.ItemOrcamentoVenda?.PermitirSobMedida
  );
  const [permiteFracionario, setPermiteFracionario] = useState(
    _initialvalues?.ItemOrcamentoVenda?.TipoUnidadeMedida == "Fracionada"
  );

  const [isProdutoFrete, setIsProdutoFrete] = useState(configs?.IDProdutoFreteVenda === _initialvalues?.ItemOrcamentoVenda?.CodProduto);

  const [isProdutoExclusivoVendedor, setIsProdutoExclusivoVendedor] = useState(
    _initialvalues?.ItemOrcamentoVenda?.Vendedores?.length > 0
  )

  const permiteEditarPrecoUnitarioEPercentualComissao =
    isProdutoExclusivoVendedor &&
    configs.UsarScriptPrecoComissao &&
    configGeral?.ConfiguracaoWeb?.ConfigWebJson?.permitirEditarPrecoUnitEPercComissaoVendedor === true;

  const refProduto = useRef(null);
  const refReferencia = useRef(null);
  const refQuantidade = useRef(null);
  const refPrecoFrete = useRef(null);

  const [focusNoCampoQuantidade, setFocusNoCampoQuantidade] = useState();
  const [focusNoCampoProduto, setFocusNoCampoProduto] = useState();

  const handleOpenModalAtalhos = () => {
    setModalAtalhos(!modalAtalhos);
  };

  const handleAtalhoCancelItem = () => {
    toggle()
    setModalAtalhos(false)
  }

  const setFocusCodProduto = () => {
    refProduto.current?.focus();
  }

  const setFocusReferencia = () => {
    refReferencia.current?.focus();
  }
  const setFocusQuantidade = () => {
    refQuantidade.current?.focus();
  }

  useEffect(() => {
    setFocusNoCampoProduto(true);
    setFocusCodProduto();
    { configs.UsarScriptPrecoComissao && selectedItem && CarregarPrecos(selectedItem.CodProduto) };
  }, [])

  const handleAtalhos = (event) => {
    const atalhoAbrirModal = "KeyM"
    const atalhoFecharModalItemAtalhos = "KeyL"
    const atalhoConfirmarItem = "KeyC"
    const atalhoFocoProduto = "KeyP"
    const atalhoFocoReferencia = "KeyR"
    const atalhoQuantidade = "KeyQ"

    if (event.altKey && (event.code.toLowerCase() === atalhoAbrirModal.toLowerCase())) {
      handleOpenModalAtalhos();
    } else if (event.altKey && (event.code.toLowerCase() === atalhoFecharModalItemAtalhos.toLowerCase())) {
      handleAtalhoCancelItem();
    } else if (event.altKey && (event.code.toLowerCase() === atalhoConfirmarItem.toLowerCase())) {
      formikRef && formikRef.current.handleSubmit()
    } else if (event.altKey && (event.code.toLowerCase() === atalhoFocoProduto.toLowerCase())) {
      setFocusCodProduto();
    } else if (event.altKey && (event.code.toLowerCase() === atalhoFocoReferencia.toLowerCase())) {
      setFocusReferencia();
    } else if (event.altKey && (event.code.toLowerCase() === atalhoQuantidade.toLowerCase())) {
      setFocusQuantidade();
    }
  };

  useAtalhos(handleAtalhos);

  const [atributos, setAtributos] = useState(
    _initialvalues?.ItemOrcamentoVenda?.Atributos
  );

  const [unidadeMedida, setUnidadeMedida] = useState(
    _initialvalues?.ItemOrcamentoVenda?.UnidadeMedidaComercial
  );
  const [precoTabela, setPrecoTabela] = useState(
    _initialvalues?.ItemOrcamentoVenda?.PrecoTabela
  );
  const [precoTabelaComDesconto, setPrecoTabelaComDesconto] = useState(
    _initialvalues?.ItemOrcamentoVenda?.PrecoTabelaComDesconto
  );
  const [precoUnitario, setPrecoUnitario] = useState(
    _initialvalues?.ItemOrcamentoVenda?.PrecoUnitario
  );
  const [percentualComissao, setPercentualComissao] = useState(
    _initialvalues?.ItemOrcamentoVenda?.PercentualComissao
  );
  const [totalItem, setTotalItem] = useState(
    _initialvalues?.ItemOrcamentoVenda?.TotalItem
  );
  const [calcular, setCalcular] = useState(false);

  const [loadErro, setLoadErro] = useState(false);
  const [erros, setErros] = useState(null);
  const [loadingDesconto, setLoadingDesconto] = useState(false);
  const [loadingGlobal, setLoadingGlobal] = useState(false);

  const [modalDescontoEspecial, setModalDescontoEspecial] = useState();

  const [ultimoProjeto, setUltimoProjeto] = useState();

  const constantes = T();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  function onLoad(loading) {
    //setLoad(loading);
  }

  function onModelNotFound(values) {
    values.ItemOrcamentoVenda.FormulaParaQuantidadeId = null;
    values.ItemOrcamentoVenda.NomeProduto = "";
    values.ItemOrcamentoVenda.CodProduto = "";
    values.ItemOrcamentoVenda.ReferenciaProduto = "";
    { configs.UsarScriptPrecoComissao && setValoresComissoes([]) };

    setUnidadeMedida("");
  }

  function onError(error) {
    const _erro = error?.response
      ? error?.response.data.error.message
      : error.message;

    setErros(_erro);
    setLoadErro(true);
  }

  function onToogleErro() {
    setLoadErro((prevvalue) => !prevvalue);
    setErros(null);
  }

  function CarregarPrecos(
    codproduto
  ) {
    setValoresComissoes([]);
    ProdutoService.getPrecosViaScript(codproduto, orcamentovenda.CondicaoPagamentoVinculado.Id, orcamentovenda.Cliente.Id, orcamentovenda.PercentualAcrescimoPadrao)
      .then((response) => {
        setValoresComissoes(response.data.value);
      })
      .catch((error) => {
        const _error = error?.response?.data
          ? error.response.data.error
          : error;
        onError && onError(_error);
      })
  }

  useEffect(() => {
    setIndexPrecoComissao(getIndexPrecoComissao({
      Preco: precoUnitario,
      PercentualComissao: percentualComissao
    }))

  }, [valoresComissoes])

  function getIndexPrecoComissao(item) {
    const index = valoresComissoes?.findIndex((preco) => {
      return preco.Preco === item.Preco && preco.PercentualComissao === item.PercentualComissao
    }
    )
    return index
  }

  function AtualizarCalculo(
    setFieldValue,
    values,
    resetForm,
    codproduto,
    nomeproduto
  ) {
    if (orcamentovenda && codproduto) {
      onLoad && onLoad(true);

      const _orcamentovenda = JSON.parse(JSON.stringify(orcamentovenda));

      const _itemorcamentovenda = JSON.parse(
        JSON.stringify(values.ItemOrcamentoVenda)
      );
      _itemorcamentovenda.CodProduto = codproduto;
      _itemorcamentovenda.NomeProduto = nomeproduto;
      _itemorcamentovenda.PercentualComissao = percentualComissao;
      _itemorcamentovenda.IdentificacaoProjeto =
        _itemorcamentovenda.IdentificacaoProjeto ?? ultimoProjeto;

      let indexitem = -1;
      if (selectedItem && indexselectedItem != null) {
        _orcamentovenda.Itens[indexselectedItem] = _itemorcamentovenda;
        indexitem = indexselectedItem;
      } else {
        _orcamentovenda.Itens =
          _orcamentovenda.Itens.concat(_itemorcamentovenda);
        indexitem = orcamentovenda.Itens.length;
      }

      OrcamentoVendaService.Calcular(_orcamentovenda)
        .then((response) => {
          const itemorcamentovenda = response.data.Itens[indexitem];

          if (itemorcamentovenda.Quantidade === 0) {
            itemorcamentovenda.Quantidade = null;
            itemorcamentovenda.TotalItem = 0;
          }

          setFieldValue("ItemOrcamentoVenda", itemorcamentovenda);
          SetDadosProdutoDeItem(itemorcamentovenda);

          if (itemorcamentovenda.Quantidade === 0) {
            setTotalItem(0);
          }
          setLoadingDesconto(false);
          setLoadingGlobal(false);
          setDeveRecalcular(false);
        })
        .catch((error) => {
          const _error = error?.response?.data
            ? error.response.data.error
            : error;
          onError && onError(_error);
          resetForm();
        })
        .finally(() => {
          onLoad && onLoad(false);
          setCalcular(false);
        });
    }
  }

  function SetDadosProdutoDeItem(item) {
    setUnidadeMedida(item?.UnidadeMedidaComercial);
    setPrecoTabela(item?.PrecoTabela);
    setPrecoTabelaComDesconto(item?.PrecoTabelaComDesconto);
    setPrecoUnitario(item?.PrecoUnitario);
    setPercentualComissao(item?.PercentualComissao);
    setTotalItem(item?.TotalItem);
    setPermiteFracionario(item?.TipoUnidadeMedida == "Fracionada");
    setIsProdutoExclusivoVendedor(item?.Vendedores?.length > 0);
    setMultiplos(item?.QtdeMultiplaVenda);
    setDevePreencherAtributos(
      configs?.UsarAtributosVenda && item?.FormulaParaQuantidadeId > 0
    );

    setIsProdutoFrete(configs?.IDProdutoFreteVenda === item?.CodProduto);
    setDeveMostrarSobMedida(item?.PermitirSobMedida);
  }

  const IdentificacaoItem = () => {
    const { values, setFieldValue, resetForm } = useFormikContext();

    return (
      <Container>
        <Stack direction="horizontal" gap={3}>
          <EditControl
            name="ItemOrcamentoVenda.Item"
            placeholder={constantes.Item}
            type="number"
            disabled
          />
          <EditControl
            name="ItemOrcamentoVenda.Id"
            placeholder="Id"
            type="number"
            disabled
          />
          <div className="p-2 ms-auto d-none d-md-block" />
          <div className="vr d-none d-md-block" />
          <div className="p-0 d-none d-md-block">
            <Stack>
              <strong>{constantes.Atalhos}</strong>
              {values?.ItemOrcamentoVenda.TabelaPrecoId && (
                <small>
                  {" "}
                  {constantes.UsandoTabeladePreco}{" "}
                  {values?.ItemOrcamentoVenda?.TabelaPrecoId}{" "}
                </small>
              )}
              {values?.ItemOrcamentoVenda.Cfop && (
                <small>
                  {constantes.Usandocfop} {values?.ItemOrcamentoVenda?.Cfop.Id}
                </small>
              )}
              {values?.ItemOrcamentoVenda.QtdeMultiplaVenda && (
                <small>
                  {" "}
                  {constantes.Multiplode}{" "}
                  {values?.ItemOrcamentoVenda.QtdeMultiplaVenda}
                </small>
              )}
              {configs.UsarScriptPrecoComissao && (
                <small>
                  Usando Preco por Script
                </small>
              )
              }
            </Stack>
          </div>
        </Stack>
      </Container>
    );
  };

  const PercentualComissao = () => {
    return (
      <Col>
        <EditControl
          type="Number"
          name="ItemOrcamentoVenda.PercentualComissao"
          placeholder={constantes.PercentualComissao}
          onBlur={(e) => {
            setPercentualComissao(Number(e.target.value))
          }}
          disabled={loadingGlobal || !permiteEditarPrecoUnitarioEPercentualComissao}
        />
      </Col>
    )
  }

  const SelecaoReferencia = () => {
    const { values, setFieldValue, resetForm } = useFormikContext();
    const { orcamentoVenda } = useContext(OrcamentoVendaContext)
    const idOperacaoVenda = orcamentoVenda?.IdOperacaoVenda;

    return (
      <Container>
        <Stack direction="horizontal" gap={3}>
          <Stack>
            <Form.Label className="mb-0">{constantes.Produto}</Form.Label>
            <CamposSearchListProduto
              autoFocus={focusNoCampoProduto}
              ref={refProduto}
              idOperacaoVenda={idOperacaoVenda}
              idTabelaPreco={TabelaPrecoId}
              disabled={somenteLeitura}
              hideTitle
              nameId="ItemOrcamentoVenda.CodProduto"
              //nameDesc="ItemOrcamentoVenda.NomeProduto"
              placeholder="Produto"
              onLoad={onLoad}
              onError={(e) => {
                e.code === "ERR_BAD_REQUEST" && e.response && e.response.status === 404
                  && onModelNotFound(values);
                onError(e);
              }}
              style={{ width: 1000 }}
              onBlur={(e) => {
                setFocusNoCampoProduto(false)
                setFocusNoCampoQuantidade(true)
              }}
              onChange={(e) => {
                setFocusNoCampoProduto(true)
                setFocusNoCampoQuantidade(false)
                setDeveRecalcular(true);
              }}
              onItemSelected={(item) => {
                values.ItemOrcamentoVenda.FormulaParaQuantidadeId = item.FormulaParaQuantidadeId;
                values.ItemOrcamentoVenda.Quantidade = 0;

                setDevePreencherAtributos(
                  configs?.UsarAtributosVenda &&
                  item?.FormulaParaQuantidadeId > 0
                );
                setDeveMostrarSobMedida(item?.PermitirSobMedida);
                setIsProdutoExclusivoVendedor(item?.Vendedores?.length > 0);
                setLoadingGlobal(true);
                setIsProdutoFrete(configs?.IDProdutoFreteVenda === item?.Id);

                if (configs.UsarScriptPrecoComissao) {
                  values.ItemOrcamentoVenda.PrecoUnitario = 0;
                  values.ItemOrcamentoVenda.PercentualComissao = 0;
                }

                AtualizarCalculo(
                  setFieldValue,
                  values,
                  resetForm,
                  item.Id,
                  item.Nome
                );

                if (configs.UsarScriptPrecoComissao) {
                  CarregarPrecos(item.Id);
                }

                setFocusNoCampoProduto(false)
                setFocusNoCampoQuantidade(true)
              }}
            />
          </Stack>

          <div className="vr d-none d-md-block" />

          <Stack>
            <Form.Label className="mb-0">{constantes.Referencia}</Form.Label>
            <NewSearchListReferenciaProduto
              ref={refReferencia}
              disabled={somenteLeitura}
              idOperacaoVenda={idOperacaoVenda}
              idTabelaPreco={TabelaPrecoId}
              hideTitle
              nameId="ItemOrcamentoVenda.ReferenciaProduto"
              //nameDesc="ItemOrcamentoVenda.NomeProduto"
              placeholder={constantes.Referencia}
              onLoad={onLoad}
              onError={(e) => {
                e.code === "ERR_BAD_REQUEST" && e.response && e.response.status === 404
                  && onModelNotFound(values);
                onError(e);
              }}
              style={{ width: 1000 }}
              onItemSelected={(item) => {
                values.ItemOrcamentoVenda.FormulaParaQuantidadeId = item.FormulaParaQuantidadeId;
                values.ItemOrcamentoVenda.Vendedores = item.Vendedores;

                setDevePreencherAtributos(
                  configs?.UsarAtributosVenda &&
                  item?.FormulaParaQuantidadeId > 0
                );
                setDeveMostrarSobMedida(item?.PermitirSobMedida);
                setIsProdutoExclusivoVendedor(item?.Vendedores?.length > 0);
                setIsProdutoFrete(configs?.IDProdutoFreteVenda === item?.Id);

                if (configs.UsarScriptPrecoComissao) {
                  values.ItemOrcamentoVenda.PrecoUnitario = 0;
                  values.ItemOrcamentoVenda.PercentualComissao = 0;
                }

                AtualizarCalculo(
                  setFieldValue,
                  values,
                  resetForm,
                  item.Id,
                  item.Nome
                );

                if (configs.UsarScriptPrecoComissao) {
                  CarregarPrecos(item.Id);
                }
              }}
            />
          </Stack>
        </Stack>
      </Container>
    );
  };

  const SelecaoProduto = () => {
    const { values, setFieldValue, resetForm, handleChange } = useFormikContext();

    return (
      <Container>
        <Stack direction="horizontal" gap={2} className="align-items-stretch">
          <div className="p-0" style={{ width: "100%" }}>
            <div
              className="form-control"
              style={{
                minHeight: "38px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                backgroundColor: "rgb(233, 236, 239)",
              }}
            >
              {values.ItemOrcamentoVenda.NomeProduto}
            </div>
          </div>
          <div className="p-0">
            {loadingGlobal ? (
              <Spinner animation="border" size="10" variant="secondary" />
            ) : (
              <Button
                variant="outline-secondary"
                disabled={!values.ItemOrcamentoVenda.CodProduto}
                type="button"
                onClick={(e) => {
                  setModalComposicao(true);
                }}
                style={{ height: "100%", width: 60, alignContent: "bottom" }}
              >
                <FontAwesomeIcon icon={faBox}></FontAwesomeIcon>
              </Button>
            )}
          </div>
        </Stack>
      </Container>
    );
  };

  const addCondicaoEspecial = (condicao, setFieldValue, values, resetForm) => {
    const itemOrcamento = {
      ...values.ItemOrcamentoVenda,
      CondicoesEspeciais: [
        ...(values.ItemOrcamentoVenda.CondicoesEspeciais ?? []),
        condicao,
      ],
    };

    values.ItemOrcamentoVenda = itemOrcamento;

    AtualizarCalculo(
      setFieldValue,
      values,
      resetForm,
      values.ItemOrcamentoVenda.CodProduto
    );
  };

  const ItemOrcamentoVendaCondicaoEspecial = (props) => {
    const { setFieldValue, values, resetForm } = useFormikContext();

    const refDescontoEspecial = useRef();
    const refJustificativa = useRef();

    return (
      <>
        {/* {vendedorSimulado && */}
        <Modal
          {...props}
          fullscreen={"xl-down"}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={modalDescontoEspecial}
          onHide={() => {
            setModalDescontoEspecial(false);
          }}
          backdrop="static"
          keyboard={false}
          className={props.className}
        >
          <ModalHeader toggle={toggle} closeButton></ModalHeader>
          <ModalBody>
            <Form.Label>{constantes.DescontoEspecialExtra}</Form.Label>
            <Form.Control
              type="Number"
              ref={refDescontoEspecial}
              onWheel={(e) => e.target.blur()}
            />
            <Form.Label>{constantes.Justificativa}</Form.Label>
            <Form.Control ref={refJustificativa} />
          </ModalBody>
          <ModalFooter>
            <Button
              bsPrefix="ButtonStyle DescontoEspecialOk"
              onClick={() => {
                addCondicaoEspecial(
                  {
                    PercentualDescontoEspecial: Number(
                      refDescontoEspecial.current.value
                    ),
                    Justificativa: refJustificativa.current.value,
                  },
                  setFieldValue,
                  values,
                  resetForm
                );
                setModalDescontoEspecial(false);
              }}
            >
              {constantes.ok}
            </Button>
          </ModalFooter>
        </Modal>
        {configs?.HabilitarDescontoEspecial && !somenteLeitura && (
          <Button
            bsPrefix="ButtonStyle adicionarDescontoEspecial"
            onClick={() => {
              setModalDescontoEspecial(true);
            }}
          >
            <FontAwesomeIcon icon={faAdd} />
          </Button>
        )}
      </>
    );
  };

  const CondicaoEspecialItem = (props) => {
    const {
      name,
      placeholder,
      namedefault,
      valuecalculated,
      hideTitle,
      disabled,
      lado,
      onBlur,
      value,
      heightLabel,
    } = props;
    const [fieldId, metaId, handleId] = useField(name ?? null);

    const hasValueCalculated = valuecalculated > 0 ? true : false;

    const { handleChange, errors, isValid } = useFormikContext();

    return (
      <>
        <Form.Label style={{ height: heightLabel ?? 40 }} htmlFor={placeholder}>
          {placeholder}
        </Form.Label>
        <InputGroup>
          <Form.Control
            {...props}
            style={{ maxWidth: 250 }}
            id={placeholder}
            name={name ?? null}
            type="number"
            value={value ? value : metaId.value}
            onChange={(e) => {
              handleChange(e);
            }}
            onWheel={(e) => e.target.blur()}
            aria-describedby={placeholder}
            placeholder="0,00"
            disabled={true}
          />
          <ItemOrcamentoVendaCondicaoEspecial />
        </InputGroup>

        {hasValueCalculated && (
          <Form.Text id={placeholder} muted>
            {constantes.Tabela} ({format_percent_2.format(valuecalculated ?? 0)}
            )
          </Form.Text>
        )}

        <ErrorMessage name={name}>
          {(msg) => <Badge bg="danger">{msg}</Badge>}
        </ErrorMessage>
      </>
    );
  };

  const Descontos = () => {
    const { setFieldValue, values, resetForm } = useFormikContext();

    return (
      <Container>
        <Row style={{ textAlign: "left" }}>
          {/* <Col style={{ textAlign: 'right' }} >
                        <Stack>
                            <p />
                            <p />
                            <p />
                            <Form.Label>%</Form.Label>
                            <Form.Label>Tabela</Form.Label>
                        </Stack>
                    </Col> */}
          {configs?.QuantidadeMaximaDescontos > 0 &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CalculatedControl
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDesconto1Praticado"
                  valuecalculated={descontosTabela?.PercentualDesconto1Tabela}
                  placeholder={constantes.PercentualDesconto1}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}
          {configs?.QuantidadeMaximaDescontos > 1 &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CalculatedControl
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDesconto2Praticado"
                  valuecalculated={descontosTabela?.PercentualDesconto2Tabela}
                  placeholder={constantes.PercentualDesconto2}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}

          {configs?.QuantidadeMaximaDescontos > 2 &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CalculatedControl
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDesconto3Praticado"
                  valuecalculated={descontosTabela?.PercentualDesconto3Tabela}
                  placeholder={constantes.PercentualDesconto3}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}

          {configs?.QuantidadeMaximaDescontos > 3 &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CalculatedControl
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDesconto4Praticado"
                  valuecalculated={descontosTabela?.PercentualDesconto4Tabela}
                  placeholder={constantes.PercentualDesconto4}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}
          {configs?.QuantidadeMaximaDescontos > 4 &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CalculatedControl
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDesconto5Praticado"
                  valuecalculated={descontosTabela?.PercentualDesconto5Tabela}
                  placeholder={constantes.PercentualDesconto5}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}

          {/* </Row>
                <Row style={{ textAlign: 'left' }}> */}
          {configs?.HabilitarDescontoEspecial &&
            configs?.PermitirAlterarDescontosVenda && (
              <Col>
                <CondicaoEspecialItem
                  disabled={somenteLeitura}
                  name="ItemOrcamentoVenda.PercentualDescontoEspecialPraticado"
                  placeholder={constantes.PercentualDescontoEspecial}
                  onBlur={(e) => {
                    setCalcular(true);
                  }}
                />
              </Col>
            )}

          {configs?.PermitirAlterarAcrescimoVenda && (
            <Col>
              <CalculatedControl
                disabled={somenteLeitura}
                name="ItemOrcamentoVenda.PercentualAcrescimoPraticado"
                valuecalculated={descontosTabela?.PercentualAcrescimoTabela}
                placeholder={constantes.PercentualAcrescimo}
                onBlur={(e) => {
                  setCalcular(true);
                }}
              />
            </Col>
          )}
          {configs?.PermitirAlterarAcrescimoVenda && (
            <Col>
              <CalculatedControl
                disabled={somenteLeitura}
                name="ItemOrcamentoVenda.PercentualAcrescimoEspecialPraticado"
                valuecalculated={
                  descontosTabela?.PercentualAcrescimoEspecialTabela
                }
                placeholder={constantes.PercentualAcrescimoEspecial}
                onBlur={(e) => {
                  setCalcular(true);
                }}
              />
            </Col>
          )}
          <Col
            sm
            style={{ padding: 20, marginTop: "1.65rem", alignItems: "center" }}
          >
            {!somenteLeitura &&
              (loadingDesconto ? (
                <Spinner
                  animation="border"
                  style={{ marginTop: 2, alignItems: "center" }}
                  variant="primary"
                />
              ) : (
                <Button
                  disabled={somenteLeitura}
                  bsPrefix="ButtonStyle aplicarDescontoseAcrecimos"
                  type="button"
                  onClick={(e) => {
                    setLoadingDesconto(true);
                    AtualizarCalculo(
                      setFieldValue,
                      values,
                      resetForm,
                      values.ItemOrcamentoVenda.CodProduto
                    );
                  }}
                >
                  {constantes.AplicarDescontos}{" "}
                </Button>
              ))}
          </Col>
          {values.ItemOrcamentoVenda?.CondicoesEspeciais?.length > 0 &&
            configs?.HabilitarDescontoEspecial && (
              <Col>
                <ItemOrcamentoVendaCondicoesEspeciaisCtx />
              </Col>
            )}
        </Row>
      </Container>
    );
  };

  const ItemFiname = () => {
    const itens_finame = itensFiname && itensFiname.length > 0 && (
      <Container>
        <Row>
          <Col colSpan={3}>
            <Form.Label className="mb-0">{constantes.ItensFiname}</Form.Label>
            <NewSelectControl
              disabled={somenteLeitura}
              name="ItemOrcamentoVenda.ItemFiname"
              placeholder={constantes.ItemFiname}
              hideTitle
              itens={itensFiname}
            />
          </Col>
        </Row>
      </Container>
    );

    return itens_finame ?? null;
  };

  const PrecosScript = () => {
    return (
      <Col colSpan={3}>
        <Form.Label className="mb-0">{constantes.PrecoEComissao}</Form.Label>
        {loadingGlobal ? (
          <Spinner animation="border" size="sm" variant="secondary" />
        ) : (
          ""
        )}{" "}

        <PrecosScriptControl
          disabled={somenteLeitura || !valoresComissoes}
          values={valoresComissoes}
          name="ItemOrcamentoVenda.PrecosScript"
          value={indexPrecoComissao}
          placeholder={constantes.PrecoEComissao}
          hideTitle
          onChange={(item) => {
            setPrecoTabela(item?.Preco);
            setPrecoTabelaComDesconto(item?.Preco);
            setPrecoUnitario(item?.Preco);
            setPercentualComissao(item?.PercentualComissao);
            setIndexPrecoComissao(getIndexPrecoComissao(item));
            setTotalItem(
              Number((Number(refQuantidade.current.value) * item?.Preco).toFixed(2))
            );
          }}
        />
      </Col>
    )
  }

  const PrecoUnitario = () => {
    const { setFieldValue, validateOnMount } = useFormikContext();
    const [field, meta] = useField("ItemOrcamentoVenda.PrecoUnitario");

    return (
      <Col>
        <Form.Group>
          <Form.Label className="mb-0">
            {constantes.PrecoUnitario}
          </Form.Label>

          <NumericFormat
            value={precoUnitario}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            disabled={loadingGlobal || !permiteEditarPrecoUnitarioEPercentualComissao}
            customInput={Form.Control}
            onBlur={(e) => {
              const raw = e.target.value;

              const valor = Number(
                raw
                  .replaceAll(".", "")
                  .replace(",", ".")
              ) || 0;

              setPrecoUnitario(valor);
              setFieldValue("ItemOrcamentoVenda.PrecoUnitario", valor);

              const quantidade = Number(refQuantidade.current?.value ?? 0);
              setTotalItem(Number((quantidade * valor).toFixed(2)));
            }}
          />

          {validateOnMount && meta.error && (
            <Badge bg="danger">{meta.error}</Badge>
          )}

          {!validateOnMount && meta.error && (
            <Badge bg="danger">{meta.error}</Badge>
          )}
        </Form.Group>
      </Col>
    );
  };

  const PrecoFrete = () => {
    return (
      <Col>
        <EditControl
          ref={refPrecoFrete}
          type="Number"
          name="ItemOrcamentoVenda.PrecoUnitario"
          placeholder={constantes.PrecoFrete}
          onBlur={(e) => {
            setPercentualComissao(0);
            setPrecoUnitario(Number(e.target.value))
            // setPrecoTabela(Number(e.target.value));
            // setPrecoTabelaComDesconto(Number(e.target.value));
            setTotalItem(
              Number((Number(refQuantidade.current.value) * Number(e.target.value)).toFixed(2))
            );
          }}
        />
      </Col>
    )
  }

  const PrecoTabelaComDesconto = () => {
    return (
      <Col>
        <Form.Label className="mb-0">
          {constantes.PrecoTabelaComDesconto}{" "}
          {loadingGlobal ? (
            <Spinner animation="border" size="sm" variant="secondary" />
          ) : (
            ""
          )}{" "}
        </Form.Label>
        <Form.Control
          value={format_currency_2.format(precoTabelaComDesconto ?? 0)}
          disabled
        />
      </Col>
    )
  }

  const PrecoTabela = () => {
    return (
      <Col>
        <Form.Label className="mb-0">
          {constantes.PrecoTabela}{" "}
          {loadingGlobal ? (
            <Spinner animation="border" size="sm" variant="secondary" />
          ) : (
            ""
          )}{" "}
        </Form.Label>
        <Form.Control
          value={format_currency_2.format(precoTabela ?? 0)}
          disabled
        />
      </Col>
    )
  }

  const Quantidade = () => {
    const { setFieldValue } = useFormikContext();

    return devePreencherAtributos ? (
      <>
        <Form.Label className="mb-0">{constantes.Quantidade}</Form.Label>

        <Stack direction="horizontal" gap={2}>
          <EditControl
            ref={refQuantidade}
            disabled
            hideTitle
            type="Number"
            name="ItemOrcamentoVenda.Quantidade"
            placeholder={constantes.Quantidade}
            isValid={false}
          />
          <Button
            type="button"
            style={{
              backgroundColor: "#009180",
              color: "white",
              border: "1px solid rgba(76,77,76,0.1550595238095238)",
            }}
            onClick={() => setModalAtributos(true)}
          >
            <FontAwesomeIcon icon={faBox}></FontAwesomeIcon>
          </Button>
        </Stack>
      </>
    ) : (
      <EditControl
        autoFocus={focusNoCampoQuantidade}
        ref={refQuantidade}
        disabled={somenteLeitura || devePreencherAtributos || loadingGlobal}
        type="Number"
        min={0}
        name="ItemOrcamentoVenda.Quantidade"
        placeholder={constantes.Quantidade}
        isValid={false}
        onChange={(e) => {
          let valor = Number(e.target.value) || 0;

          if (valor < 0) valor = 0;

          setFieldValue("ItemOrcamentoVenda.Quantidade", valor);
        }}
        onBlur={(e) => {
          let valor = Number(e.target.value) || 0;

          if (valor < 0) valor = 0;

          setFieldValue("ItemOrcamentoVenda.Quantidade", valor);

          setTotalItem(
            Number((valor * precoUnitario).toFixed(2))
          );

          setFocusNoCampoProduto(false);
          setFocusNoCampoQuantidade(false);
        }}
      />
    );
  };

  const QuantidadeEPrecos = () => {
    const { values, setFieldValue, resetForm, handleChange } =
      useFormikContext();

    return (
      <Container>
        <Row xs={1} md={3}>
          <Col>
            <Quantidade />
          </Col>

          <Col>
            <Form.Label className="mb-0">
              {constantes.UnidadeMedida}{" "}
              {loadingGlobal ? (
                <Spinner animation="border" size="sm" variant="secondary" />
              ) : (
                ""
              )}{" "}
            </Form.Label>

            <Form.Control value={unidadeMedida} disabled />
          </Col>
          {!configs.UsarScriptPrecoComissao && <PrecoTabela />}
        </Row>
        <Row xs={1} md={2} lg={4}>
          {!configs.UsarScriptPrecoComissao && <PrecoTabelaComDesconto />}
          {!configs.UsarScriptPrecoComissao && <PrecoUnitario />}
          {configs.UsarScriptPrecoComissao && isProdutoFrete && <PrecoFrete />}
          {configs.UsarScriptPrecoComissao && !isProdutoFrete && <PrecosScript />}
          {configs.UsarScriptPrecoComissao && <PrecoUnitario />}
          {configs.UsarScriptPrecoComissao && <PercentualComissao />}
          <Col>
            <Form.Label className="mb-0">{constantes.TotalItem} </Form.Label>
            <Form.Control
              style={{
                fontSize: 25,
                height: "38px",
                textAlign: "right",
                fontWeight: "bold",
              }}
              value={format_currency_2.format(totalItem ?? 0)}
              disabled
            />
          </Col>
        </Row>
      </Container>
    );
  };

  const Modals = () => {
    const { values, setFieldValue, resetForm, handleChange } =
      useFormikContext();

    return (
      <Container>
        <ModalComposicaoProdutoControl
          id={values.ItemOrcamentoVenda.CodProduto}
          idBusca={""}
          modal={modalComposicao}
          closeModal={() => {
            setModalComposicao(false);
          }}
          apenasVisualizar={true}
          titleModal={constantes.ComposicaoProduto}
        >
          <NewComposicaoProdutoControl
            constantes={constantes}
            id={values.ItemOrcamentoVenda.CodProduto}
          />
        </ModalComposicaoProdutoControl>


        <ModalAtributosProdutoControl
          id={values.ItemOrcamentoVenda.CodProduto}
          atributos={atributos}
          somenteLeitura={somenteLeitura}
          modal={modalAtributos}
          quantidadeCalculada={values.ItemOrcamentoVenda.Quantidade}
          setQuantidadeCalculada={(atributos, qtd) => {
            setFieldValue("ItemOrcamentoVenda.Quantidade", Number(qtd));
            setFieldValue("ItemOrcamentoVenda.Atributos", atributos);
            setTotalItem(Number((Number(qtd) * precoUnitario).toFixed(2)));
            setAtributos(atributos);
            setModalAtributos(false);
          }}
          toggle={() => {
            setModalAtributos(false);
          }}
        />
        <ErrosModal onHide={onToogleErro} show={loadErro} erro={erros} />
      </Container>
    );
  };

  function isMultiploAproximado(divisor, dividendo) {
    const remainder = divisor % dividendo;
    const tolerance = 0.00001; // Margem de erro aceitável
    return Math.abs(remainder) < tolerance || Math.abs(remainder - dividendo) < tolerance;
  }

  return (
    <>
      <Formik
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={selectedItem ? _initialvalues : initialValues}
        //TotalItem: Yup.number().moreThan(0, " deve ser > 0").required("Deve ser preenchido"),//

        validationSchema={Yup.object({
          ItemOrcamentoVenda: Yup.object({
            CodProduto: Yup.string().required("Deve ser preenchido"),
            Quantidade: Yup.string().required("Deve ser preenchido"),
            PrecoUnitario: Yup.string().required("Deve ser preenchido"),
          }),
        })}
        validate={(values, isValidating) => {
          let errors = {};

          if (values.ItemOrcamentoVenda.Quantidade <= 0) {
            return {
              ItemOrcamentoVenda: {
                Quantidade: 'A Quantidade deve ser maior que 0'
              }
            }
          }

          if (isNaN(values.ItemOrcamentoVenda.PrecoUnitario) || values.ItemOrcamentoVenda.PrecoUnitario <= 0) {
            return {
              ItemOrcamentoVenda: {
                PrecoUnitario: 'O Preço Unitário deve ser maior que 0'
              }
            }
          }

          if (multiplos && multiplos > 0) {
            if (!isMultiploAproximado(values.ItemOrcamentoVenda.Quantidade, multiplos)) {
              return {
                ItemOrcamentoVenda: {
                  Quantidade: `A Quantidade deve ser múltipla de ${multiplos}`,
                },
              };
            }
          }

          if (!permiteFracionario) {
            const valorfracionado =
              values.ItemOrcamentoVenda.Quantidade % 1 !== 0;

            if (valorfracionado) {
              return {
                ItemOrcamentoVenda: {
                  Quantidade: `Valor fracionado não é permitido para o item`,
                },
              };
            }
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm, setFieldValue }) => {
          setUltimoProjeto(values.ItemOrcamentoVenda.IdentificacaoProjeto);
          selectedItem
            ? props.onEditItem(values.ItemOrcamentoVenda)
            : props.onAddItem(values.ItemOrcamentoVenda, () => {
              setFocusCodProduto()
            });
          resetForm();
          SetDadosProdutoDeItem(initialValues);

          setTimeout(() => {
            if (refProduto.current) {
              refProduto.current.focus();
            }
          }, 1000);
          setSubmitting(false);
        }}
      >
        {({
          handleSubmit,
        }) => {


          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Modals />
              <Accordion defaultActiveKey="0">
                <Stack gap={2}>
                  <IdentificacaoItem />
                  <SelecaoReferencia />
                  <SelecaoProduto />
                  <QuantidadeEPrecos />

                  <ItemFiname />

                  {deveMostrarSobMedida && (
                    <Container>
                      <NewCheckBoxControl
                        disabled={somenteLeitura}
                        name="ItemOrcamentoVenda.SobMedida"
                        placeholder={constantes.SobMedida}
                      />
                    </Container>
                  )}

                  {!configs?.DesabilitarCamposConformePerfil && !configs.UsarScriptPrecoComissao && (
                    <Container>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          {constantes.Descontos}
                        </Accordion.Header>
                        <Accordion.Body>
                          <Descontos />
                        </Accordion.Body>
                      </Accordion.Item>
                    </Container>
                  )}

                  <Container>
                    <small>{constantes.IDProjetoGrupo}</small>
                    <NewGruposProdutosVendasControl disabled={somenteLeitura} />
                  </Container>

                  <Container>
                    <small>{constantes.Observacoes}</small>
                    <CampoMemo
                      disabled={somenteLeitura}
                      hideTitle
                      name="ItemOrcamentoVenda.Observacoes"
                      placeholder={constantes.Observacoes}
                    />
                  </Container>

                  <Container>
                    <Button
                      type="submit"
                      bsPrefix="ButtonStyle confirmar"
                      variant="primary"
                      disabled={somenteLeitura || deveRecalcular}
                    >
                      {props.continuar
                        ? constantes.AddEContinuar
                        : constantes.Confirmar}
                    </Button>
                  </Container>
                </Stack>
              </Accordion>
            </Form>
          );
        }}
      </Formik>
      <ModalAtalhos
        maxWidthModal={"md"}
        id={""}
        idBusca={""}
        modal={modalAtalhos}
        closeModal={() => {
          handleOpenModalAtalhos();
        }}
        apenasVisualizar={true}
        titleModal={constantes.AtalhosLabel}
      />
    </>

  );
};

export default ItemOrcamentoVendaNew;
